import styled, { css } from 'styled-components';
import { TableRow, TableCell } from '@mui/material';

import { mixins, colors, fonts } from '../../css';

export const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
`;

export const Details = styled.div`
  padding: ${mixins.pxToRem(5)};
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
`;

export const Tag = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  position: absolute;
  top: 0;
  left: 0;
  min-width: 150px;
  padding: ${mixins.pxToRem(5)};
  min-height: ${mixins.pxToRem(27)};
  background-color: ${colors.colorGrey04};
  ${({ theme }) => `color: ${theme.midTheme}`};
  text-align: center;
  white-space: nowrap;

  p {
    white-space: nowrap;
  }
`;

const disabledStyledButton = css`
  background-color: ${colors.colorGrey04};
  color: ${colors.colorGrey03};
  &:hover {
    background-color: ${colors.colorGrey04};
    color: ${colors.colorGrey03};
    cursor: auto;
  }
`;

export const StyledButton = styled.button`
  ${({ theme }) => `background-color: ${theme.lighterText}`};
  border: 1px solid;
  ${({ theme }) => `border-color: ${theme.lightText}`};
  ${({ theme }) => `color: ${theme.midTheme}`};
  &:hover {
    cursor: pointer;
    background-color: ${colors.colorGrey04};
  }
  white-space: nowrap;
  margin: 0;
  width: 100%;
  height: ${mixins.pxToRem(40)};
  padding: ${mixins.pxToRem(10)} ${mixins.pxToRem(20)};
  font-family: ${fonts.fontRegular};
  font-size: ${mixins.pxToRem(12)};
  letter-spacing: 1px;
  text-decoration: none;
  text-transform: uppercase;
  user-select: none;
  outline: none;
  transition: background-color 125ms;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${mixins.pxToRem(5)};
  &:hover {
    text-decoration: none;
  }
  &:not(.first) {
    margin-left: 5px;
  }
  ${({ disabled }) => disabled && disabledStyledButton};
`;

const disabledRemove = css`
  color: ${colors.colorGrey03};
  &:hover {
    color: ${colors.colorGrey03};
    cursor: auto;
  }
`;

export const StyledRemove = styled.button`
  text-align: center;
  width: 100%;
  color: ${colors.colorGrey03};
  margin-top: ${mixins.pxToRem(5)};
  text-decoration: underline;
  cursor: pointer;
  font-size: ${mixins.pxToRem(10)};
  white-space: nowrap;
  &:hover {
    ${({ theme }) => `color: ${theme.highlightTheme}`};
  }
  ${({ disabled }) => disabled && disabledRemove};
`;

// Same as StyledRemove with clearer name for rate card page
export const StyledChangeState = StyledRemove;

export const ColumnLabel = styled.div`
  color: ${colors.colorGrey03};
  padding-bottom: ${mixins.pxToRem(8)};
`;

export const ColumnValue = styled.div`
  font-size: ${mixins.pxToRem(16)};
  font-family: ${fonts.fontRegular};
  p {
    padding-bottom: 0.5rem;
  }
`;

export const ActiveColumnValue = styled(ColumnValue)`
  color: ${colors.colorGreen};
`;

export const InactiveColumnValue = styled(ColumnValue)`
  color: ${colors.colorRed};
`;

export const Cell = styled(TableCell)`
  position: relative;
  padding: ${mixins.pxToRem(6)} ${mixins.pxToRem(5)} ${mixins.pxToRem(10)} ${mixins.pxToRem(24)} !important;
  ${({ hastag }) => hastag === 'true' && `padding-top: ${mixins.pxToRem(33)} !important;`};
  height: 100%;
  vertical-align: middle !important;
  &.buttons {
    vertical-align: middle !important;
    padding-top: ${mixins.pxToRem(6)} !important;
    position: sticky;
    right: 0;
    background: #fff;
    box-shadow: -4px 0px 25px -10px rgba(0, 0, 0, 0.15);
  }
  &:last-child {
    padding: ${mixins.pxToRem(10)} !important;
  }
`;

export const ExpandedCell = styled(Cell)`
  padding: 0 !important;
`;

export const Row = styled(TableRow)`
  cursor: default;
  &.top {
    vertical-align: top !important;
    ${Cell} &:not(.buttons) {
      vertical-align: top !important;
    }
  }
  &:hover {
    ${Tag} {
      color: ${colors.colorWhite};
      ${({ theme }) => `background-color: ${theme.midTheme}`};
    }
    ${Cell}.buttons {
      ${({ theme }) => `background-color: ${theme.lighterText}`};
    }
  }
`;

export const CheckboxCell = styled(TableCell)`
  width: 40px;
  position: relative;
  padding: 0px;
  &.checkbox {
    padding-right: 40px;
  }

  .checkbox {
    position: absolute;
    width: 100%;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 14px;
    margin-right: -16px;
  }

  border-bottom: ${(props) => (props.heading ? '0 !important' : 'inherit')};
`;
